import React from "react";

export const Heart = ({ className = "", color = "#C84B31" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9z"/>
  </svg>
);

export const Paw = ({ className = "", color = "#111" }) => (
  <svg viewBox="0 0 64 64" className={className} fill={color}>
    <ellipse cx="14" cy="24" rx="6" ry="8"/>
    <ellipse cx="50" cy="24" rx="6" ry="8"/>
    <ellipse cx="22" cy="10" rx="5" ry="7"/>
    <ellipse cx="42" cy="10" rx="5" ry="7"/>
    <path d="M32 28c-9 0-16 7-16 14 0 6 5 10 16 10s16-4 16-10c0-7-7-14-16-14z"/>
  </svg>
);

export const Star = ({ className = "", color = "#C84B31" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l2.5 6.5L21 9.5l-5 4.5 1.5 7L12 17.5 6.5 21 8 14 3 9.5l6.5-1z"/>
  </svg>
);

export const Squiggle = ({ className = "", color = "#C84B31" }) => (
  <svg viewBox="0 0 120 16" className={className} fill="none" stroke={color} strokeWidth="3" strokeLinecap="round">
    <path d="M2 8 Q 15 -2, 30 8 T 60 8 T 90 8 T 118 8"/>
  </svg>
);

export const BrushStroke = ({ className = "", color = "#C84B31" }) => (
  <svg viewBox="0 0 200 18" className={className} preserveAspectRatio="none">
    <path d="M5 9 Q 50 2, 100 9 T 195 9 L 195 14 Q 100 18, 5 14 Z" fill={color}/>
  </svg>
);

export const Arrow = ({ className = "", color = "#111" }) => (
  <svg viewBox="0 0 80 40" className={className} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M5 30 Q 25 5, 50 15 T 75 12"/>
    <path d="M75 12 L 68 6 M 75 12 L 67 18"/>
  </svg>
);
